import * as React from "react";
const SvgFiRrCocktailAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cocktail-alt_svg__a)">
      <path
        fill="#062147"
        d="m14.869 12.888 8.17-7.551c2.076-1.782.48-5.448-2.2-5.337H3.159C.467-.1-1.128 3.559.99 5.365l8.146 7.528c.53.477 1.17.813 1.863.976V22H7a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2h-4v-8.13a4.26 4.26 0 0 0 1.869-.982M4.624 6H16a1 1 0 1 0 0-2H2.46a1.109 1.109 0 0 1 .7-2h17.682a1.15 1.15 0 0 1 1.076.753 1 1 0 0 1-.266 1.147l-8.135 7.516a2.25 2.25 0 0 1-1.524.59 2.24 2.24 0 0 1-1.5-.584z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cocktail-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCocktailAlt;
